export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.greetings-new', {
      url: 'greetings-new',
      template: '<nets-greetings-new></nets-greetings-new>',
    });
};
